// src/components/ClientDashboard.tsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { fetchClientForms } from '../api';
import axios from 'axios';

const ClientDashboard: React.FC = () => {
  const [forms, setForms] = useState<any[]>([]);
  const [contracts, setContracts] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchForms();
    fetchContracts();
  }, []);

  const fetchForms = async () => {
    setIsLoading(true);
    setError('');
    try {
      const token = localStorage.getItem('clientToken');
      if (!token) throw new Error('No client authentication token found.');
      const response = await fetchClientForms(token);
      setForms(response);
    } catch (error: any) {
      console.error('Failed to fetch forms:', error);
      if (error.response?.status === 401) {
        setError('Session expired. Please log in again.');
        localStorage.removeItem('clientToken');
        window.dispatchEvent(new Event('clientAuthChange'));
        navigate('/client/login');
      } else {
        setError('Failed to load forms.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const fetchContracts = async () => {
    setIsLoading(true);
    setError('');
    try {
      console.log()
      const token = localStorage.getItem('clientToken');
      if (!token) throw new Error('No client authentication token found.');
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/ClientContracts`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setContracts(response.data);
    } catch (error: any) {
      console.error('Failed to fetch contracts:', error);
      if (error.response?.status === 401) {
        setError('Session expired. Please log in again.');
        localStorage.removeItem('clientToken');
        window.dispatchEvent(new Event('clientAuthChange'));
        navigate('/client/login');
      } else {
        setError('Failed to load contracts.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <style>
        {`
          .client-dashboard-card {
            height: 400px;
            display: flex;
            flex-direction: column;
          }
          .client-dashboard-card-body {
            flex: 1;
            max-height: 300px;
            overflow-y: auto;
            padding: 1rem;
          }
          .client-dashboard-card-body::-webkit-scrollbar {
            width: 8px;
          }
          .client-dashboard-card-body::-webkit-scrollbar-thumb {
            background-color: #007bff;
            border-radius: 4px;
          }
          .client-dashboard-card-body::-webkit-scrollbar-track {
            background: #f1f1f1;
          }
        `}
      </style>
      <h2 className="mb-4 text-center">Client Dashboard</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      {isLoading && <div className="alert alert-info">Loading...</div>}
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow-sm client-dashboard-card">
            <div className="card-header bg-primary text-white">
              <h4 className="mb-0">Your Forms ({forms.length})</h4>
            </div>
            <div className="card-body client-dashboard-card-body">
              {forms.length === 0 && !isLoading && !error ? (
                <p className="text-muted text-center">No forms assigned yet.</p>
              ) : (
                <ul className="list-group list-group-flush">
                  {forms.map((form) => (
                    <li
                      key={form.id}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <div>
                        {form.name || `Form ${form.id}`}
                        <small className="d-block text-muted">
                          Status: {form.status || 'Not set'}
                        </small>
                        <small className="d-block text-muted">
                          Last Updated: {new Date(form.lastUpdated).toLocaleDateString()}
                        </small>
                      </div>
                      <Link
                        to={`/form/${form.id}`}
                        className="btn btn-outline-primary btn-sm"
                      >
                        Fill Out
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card shadow-sm client-dashboard-card">
            <div className="card-header bg-primary text-white">
              <h4 className="mb-0">Your Contracts ({contracts.length})</h4>
            </div>
            <div className="card-body client-dashboard-card-body">
              {contracts.length === 0 && !isLoading && !error ? (
                <p className="text-muted text-center">No contracts assigned yet.</p>
              ) : (
                <ul className="list-group list-group-flush">
                  {contracts.map((contract) => (
                    <li
                      key={contract.id}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <div>
                        {contract.name || `Contract ${contract.id}`}
                        <small className="d-block text-muted">
                          Status: {contract.status || 'Not set'}
                        </small>
                        <small className="d-block text-muted">
                          Last Updated: {new Date(contract.lastUpdated).toLocaleDateString()}
                        </small>
                      </div>
                      <Link
                        to={`/client/contract/${contract.id}`}
                        className="btn btn-outline-primary btn-sm"
                      >
                        View/Sign
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientDashboard;